const ShipmentFormType = {
    CARRIER: "CARRIER",
    FORWARDER: "FORWARDER"
};

export default ShipmentFormType;
